import React, { memo, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { fetchEmailTemplatesSendGrid, sortEmailTemplatesSendGrid } from 'src/actions/emailTemplatesSendGrid';
import { EmailTemplateSendGridManagement } from 'src/components/EmailTemplateSendGridManagement/index';

const EmailTemplatesManagementContainerComponent = ({
  sortEmailTemplatesSendGrid,
  fetchEmailTemplatesSendGrid,
  emailTemplates,
  isLoading,
}) => {
  useEffect(() => {
    fetchEmailTemplatesSendGrid({});
  }, []);

  const handleSortChange = name => {
    if (isLoading) {
      return;
    }
    sortEmailTemplatesSendGrid(name);
  };

  return (
    <div className="full-height">
      <Helmet title="Email Templates Management Page" />
      <EmailTemplateSendGridManagement
        emailTemplates={emailTemplates}
        isLoading={isLoading}
        onSortChange={handleSortChange}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  emailTemplates: state.emailTemplatesSendGrid.get('emailTemplates'),
  isLoading: state.emailTemplatesSendGrid.get('loading'),
});

export const EmailTemplatesSendGridManagementContainer = memo(
  connect(mapStateToProps, {
    fetchEmailTemplatesSendGrid,
    sortEmailTemplatesSendGrid,
  })(EmailTemplatesManagementContainerComponent),
);
